import { render, staticRenderFns } from "./TermDialog.vue?vue&type=template&id=68bf60dc&scoped=true&"
import script from "./TermDialog.vue?vue&type=script&lang=js&"
export * from "./TermDialog.vue?vue&type=script&lang=js&"
import style0 from "./TermDialog.vue?vue&type=style&index=0&id=68bf60dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf60dc",
  null
  
)

export default component.exports